import { CaretLeftIcon, EnvelopeSimpleIcon, PhoneIcon } from '@phosphor-icons/react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import headerBg from '@/assets/images/order-detail-header.png';
import { CopyToClipboard } from '@/components/common/copy-to-clipboard';
import { routes } from '@/config/routes';

import type { OrderDetail } from '../types';

import styles from './order-detail.module.scss';

type Props = {
  order: OrderDetail;
  /** Right-aligned cluster: status control, Invoice button, actions menu. */
  actions?: ReactNode;
};

export function OrderDetailHeader({ order, actions }: Props) {
  const navigate = useNavigate();
  const { customer, orderNumber } = order;

  return (
    <header className={styles.header} style={{ backgroundImage: `url(${headerBg})` }}>
      {/* Back to the Orders listing (AC: state not preserved — returns to page 1). */}
      <button
        type="button"
        className={styles.backCaret}
        onClick={() => navigate(routes.orders)}
        aria-label="Back to orders"
      >
        <CaretLeftIcon size={22} />
      </button>

      <div className={styles.identityCol}>
        <div className={styles.identity}>
          <h1 className={styles.customerName}>{customer.name}</h1>
          <span className={styles.orderId}>#{orderNumber}</span>
          <CopyToClipboard value={`#${orderNumber}`} />
        </div>
        <div className={styles.contacts}>
          <span className={styles.contact}>
            <PhoneIcon size={16} />
            {customer.phone}
          </span>
          {customer.email && (
            <span className={styles.contact}>
              <EnvelopeSimpleIcon size={16} />
              {customer.email}
            </span>
          )}
        </div>
      </div>

      {actions && <div className={styles.actions}>{actions}</div>}
    </header>
  );
}
